import { render } from "./AdvertisingMaterialTips.vue?vue&type=template&id=58b9b2de"
import script from "./AdvertisingMaterialTips.vue?vue&type=script&lang=js"
export * from "./AdvertisingMaterialTips.vue?vue&type=script&lang=js"

import "./AdvertisingMaterialTips.vue?vue&type=style&index=0&id=58b9b2de&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__